import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m8 0l8 8l-8 8v-4H0V4h8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsRight
